/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchRequestDto
 */
export interface SearchRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SearchRequestDto
     */
    search?: string | null;
}

/**
 * Check if a given object implements the SearchRequestDto interface.
 */
export function instanceOfSearchRequestDto(value: object): value is SearchRequestDto {
    return true;
}

export function SearchRequestDtoFromJSON(json: any): SearchRequestDto {
    return SearchRequestDtoFromJSONTyped(json, false);
}

export function SearchRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'search': json['search'] == null ? undefined : json['search'],
    };
}

export function SearchRequestDtoToJSON(json: any): SearchRequestDto {
    return SearchRequestDtoToJSONTyped(json, false);
}

export function SearchRequestDtoToJSONTyped(value?: SearchRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search': value['search'],
    };
}

